require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-virgin-media-calling-and-asking-password.json") })
        }
      }, "path---post-virgin-media-calling-and-asking-password");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-virgin-media-calling-and-asking-password!./.cache/json/post-virgin-media-calling-and-asking-password.json
// module id = 366
// module chunks = 231608221292675